import React,{useState} from 'react';

const Confirm=(props) => {
   

    if (!props.isOpen) return null;

    return(
    <div className="fixed inset-0 bg-neutral-950/50 backdrop-blur   flex items-center justify-center z-[1001]">
            <div className="bg-white rounded-md shadow-xl max-w-md w-11/12 p-6 animate-fade-in transform transition-all duration-300 ease-out">
                <div className="flex items-center justify-between mb-4">
                    <h3 className="text-lg font-semibold text-neutral-900">{props.title??''}</h3>
                    <span className="material-symbols-outlined text-neutral-500 hover:text-neutral-700 cursor-pointer transition-colors"  onClick={props.onClose} >
                        close
                    </span>
                </div>
                <div className="mb-6">
                    <p className="text-neutral-700 mb-2">
                        {props.message??''}
                    </p>
                    
                </div>
                <div className="grid grid-cols-2 gap-4 mb-4">
                    <button 
                        className="w-full bg-neutral-200 text-neutral-800 py-3 rounded-xl font-medium hover:bg-neutral-300  transition-all transform hover:scale-[1.01] active:scale-[0.99]"
                        onClick={props.onClose}    
                    >
                        Cancelar
                    </button>
                    <button 
                        className="w-full bg-[red] text-white py-3 rounded-xl font-medium hover:bg-white  hover:text-[red] transition-all transform hover:scale-[1.01] active:scale-[0.99]"
                        onClick={props.onConfirm}    
                    >
                        {props.confirmText??'Confirmar'}
                    </button>
                </div>
                {/* Next: "Add a subtle progress indicator" */}
            </div>
        </div>
    );
}

export default Confirm;